import { execFileSync } from 'node:child_process'
import path from 'node:path'
import { OXFMT_FORMAT_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { resolveLocalBin } from '@cli-utils/process.js'
import { normalizeLineEndings } from '@cli-utils/text.js'
import { canFormatWithOxfmt } from './can-format-with-oxfmt.js'

export function formatContentForSnapshotMerge(
  cwd: string,
  filePath: string,
  content: string
): string | null {
  if (!canFormatWithOxfmt(filePath)) {
    return null
  }

  const oxfmtBin = resolveLocalBin(cwd, 'oxfmt')
  if (!oxfmtBin) {
    return null
  }

  const targetPath = path.join(cwd, ...filePath.split('/'))

  try {
    return execFileSync(oxfmtBin, ['--stdin-filepath', targetPath], {
      cwd,
      encoding: 'utf-8',
      input: normalizeLineEndings(content),
      stdio: ['pipe', 'pipe', 'ignore'],
      timeout: OXFMT_FORMAT_TIMEOUT_MS
    })
  } catch {
    return null
  }
}
